import { sideBarNavigate } from "../partnerWeb_Dashboard/utils";
import { getParameters, isEmpty } from "../../configs/utils";
import sharedPropsService from "../../SharedPropsService";
import SharedPropsService from "../../SharedPropsService";
import { api, StoreKey } from "../../configs/api";
import { getAppHeader, getAuthHeaders, RegexConfig } from "../../configs/config";
import { InputStateToken } from "@voltmoney/schema";
import { GoogleUtmParams } from "../../configs/constants";
import { ROUTE } from "../../routes";
import { Platform } from "react-native";
export const onChangeTab = async (action, _datastore, standardUtilities) => {
    await sideBarNavigate(standardUtilities, action);
};
export const onChangeInputOtp = async (action, _datastore, { navigateWithClear, network, asyncStorage, setDatastore, navigate }) => {
    console.warn("**** onChangeInputOtp Action Triggered ****", action);
    const otp = action.payload.otp;
    // const verifyOtpData = await sharedPropsService.getMfCentralInitResponse();
    const leadId = action.payload.leadId;
    const isResend = action.payload.isResend;
    const reqId = action.payload.reqId;
    const otpRef = action.payload.otpRef;
    const clientRefNo = action.payload.clientRefNo;
    if (otp?.length === 6) {
        await setDatastore(action.routeId, 'OtpInput', {
            state: InputStateToken.LOADING
        });
        const mfCentralVerifyOtpRequestBody = {
            reqId: reqId,
            otpRef: otpRef,
            otp: otp,
            leadId: leadId,
            clientRefNo: clientRefNo
        };
        // verify Otp call
        // const header = await getAppHeader();
        // header['Authorization'] = `Bearer ${await asyncStorage.get(StoreKey.PLATFORM_AUTH_TOKEN)}`;
        const mfCentralVerifyOtpResponse = await network.post(`${api.MFCentralVerifyOtpV2}`, mfCentralVerifyOtpRequestBody, {
            headers: await getAuthHeaders()
        }, async () => { return; }, {
            isPartnerPlatform: true
        });
        console.log("mfCentralVerifyOtpResponse: ", mfCentralVerifyOtpResponse);
        if (mfCentralVerifyOtpResponse?.status === 200) {
            await asyncStorage.set(StoreKey.LEAD_TOKEN, mfCentralVerifyOtpResponse?.data?.jwt);
            // await setDatastore(
            //     action.routeId,
            //     'OtpInput',
            //     <TextInputProps & TextInputOtpProps> {
            //         state: InputStateToken.SUCCESS
            //     }
            // )
            await setDatastore(action.routeId, 'customerPortfolioPage', {
                otpInputState: InputStateToken.SUCCESS,
            });
            // await navigateWithClear(ROUTE.CHECK_LIMIT_LOADING, {leadId: leadId})
            await setDatastore(action.routeId, 'customerPortfolioPage', {
                activeScreen: "PORTFOLIO_LOADING" /* CHECK_CUSTOMER_PORTFOLIO_SCREEN_TYPE.PORTFOLIO_LOADING */
            });
            //
            let interval;
            const headers = await getAppHeader();
            headers['Authorization'] = `Bearer ${await asyncStorage.get(StoreKey.LEAD_TOKEN)}`;
            // eslint-disable-next-line prefer-const
            interval = setInterval(async () => {
                const assetDetailsResponse = await network.get(`${api.getCustomerLeadsAssetDataV2}`, {
                    headers: headers
                }, async () => { return; }, {
                    disableDefault: true
                });
                if (assetDetailsResponse?.status === 200) {
                    clearInterval(interval);
                    await sharedPropsService.setCustomerLeadAssetData(assetDetailsResponse?.data);
                    if (Platform.OS === 'web') {
                        localStorage.setItem('leadData', JSON.stringify(assetDetailsResponse?.data));
                    }
                    await setDatastore(action.routeId, 'customerPortfolioPage', {
                        activeScreen: "DATA_TABLE_SCREEN" /* CHECK_CUSTOMER_PORTFOLIO_SCREEN_TYPE.DATA_TABLE_SCREEN */,
                        assetDetails: assetDetailsResponse?.data
                    });
                }
                else if (assetDetailsResponse?.response?.status === 400 && assetDetailsResponse?.response?.data?.voltErrorCode === 'MF_PORTFOLIO_NOT_FOUND') {
                    clearInterval(interval);
                    // await navigateWithClear(ROUTE.CHECK_LIMIT_NO_MF);
                    await setDatastore(action.routeId, 'customerPortfolioPage', {
                        activeScreen: "NO_PORTFOLIO_SCREEN" /* CHECK_CUSTOMER_PORTFOLIO_SCREEN_TYPE.NO_PORTFOLIO_SCREEN */,
                    });
                }
                else if (assetDetailsResponse?.response?.status === 500) {
                    clearInterval(interval);
                    // await navigateWithClear(ROUTE.CHECK_LIMIT_ALERT_MODAL);
                }
            }, 5000);
        }
        else if (mfCentralVerifyOtpResponse?.response?.status === 400) {
            console.log("here otp: ", mfCentralVerifyOtpResponse?.response?.data?.voltErrorCode);
            // await setDatastore(
            //     action.routeId,
            //     'OtpInput',
            //     <TextInputProps & TextInputOtpProps> {
            //         state: InputStateToken.ERROR,
            //         caption: {
            //             error: `${mfCentralVerifyOtpResponse?.response?.data?.message}`
            //         }
            //     }
            // )
            await setDatastore(action.routeId, 'customerPortfolioPage', {
                otpInputState: InputStateToken.ERROR,
                otpErrorMessage: `${mfCentralVerifyOtpResponse?.response?.data?.message}`
            });
            if (mfCentralVerifyOtpResponse?.response?.data?.voltErrorCode == 'MF_OTP_ATTEMPTS_EXHAUSTED') {
                console.log("here: otp");
                // await setDatastore(
                //     action.routeId,
                //     'OtpInput',
                //     <TextInputProps & TextInputOtpProps> {
                //         state: InputStateToken.DISABLED,
                //         otpLimitExceeded: true,
                //     },
                // )
                await setDatastore(action.routeId, 'customerPortfolioPage', {
                    otpInputState: InputStateToken.DISABLED,
                    otpLimitExceeded: true
                });
            }
            // await navigate(ROUTE.CHECK_LIMIT_ALERT_MODAL)
        }
        else if (mfCentralVerifyOtpResponse?.response?.status === 500) {
            // await navigate(ROUTE.CHECK_LIMIT_ALERT_MODAL)
            // await setDatastore(
            //     action.routeId,
            //     'OtpInput',
            //     <TextInputProps & TextInputOtpProps> {
            //         state: InputStateToken.ERROR,
            //         caption: {
            //             error: `${mfCentralVerifyOtpResponse?.response?.data?.message}`
            //         }
            //     }
            // )
            await setDatastore(action.routeId, 'customerPortfolioPage', {
                otpInputState: InputStateToken.ERROR,
                otpErrorMessage: `${mfCentralVerifyOtpResponse?.response?.data?.message}`
            });
        }
        else {
            // await setDatastore(
            //     action.routeId,
            //     'OtpInput',
            //     <TextInputProps & TextInputOtpProps> {
            //         state: InputStateToken.ERROR,
            //         caption: {
            //             error: `${mfCentralVerifyOtpResponse?.response?.data?.message}`
            //         }
            //     }
            // )
            await setDatastore(action.routeId, 'customerPortfolioPage', {
                otpInputState: InputStateToken.ERROR,
                otpErrorMessage: `${mfCentralVerifyOtpResponse?.response?.data?.message}`
            });
        }
    }
};
export const getOTP = async (action, _datastore, { navigateWithClear, network, asyncStorage, setDatastore, instrumentTrack, addUseProperty, navigate, initializeAmplitude, }) => {
    console.warn("**** getOTP Action Triggered ****", action);
    const isResend = action?.payload?.isResend === true;
    const pan = action.payload.pan;
    const phone = action.payload.phone;
    const _user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
    let refUrl = getParameters(window.location.href);
    let ref = refUrl.ref;
    let leadId = '';
    await sharedPropsService.setCheckLimitInitData({
        pan: pan,
        phoneNumber: phone
    });
    await asyncStorage.set(StoreKey.U_DATA, JSON.stringify({
        pan: pan,
        phoneNumber: phone,
        skipNavigateToRegisterLeads: true
    }));
    const panRegex = new RegExp(RegexConfig.PAN);
    const isPanValid = panRegex.test(pan);
    const phoneNumberRegex = new RegExp(RegexConfig.NEW_MOBILE);
    const isPhoneNumberValid = phoneNumberRegex.test(phone);
    let clientRefNo;
    let otpRef;
    let reqId;
    if (isPanValid && isPhoneNumberValid) {
        // await setDatastore(action.routeId, 'continue', <ButtonProps>{
        //     loading: true
        // })
        const urlParams = `${await SharedPropsService.getUrlParams()}`.split("?");
        const requestUrl = `${api.login}${phone}`;
        const params = urlParams ? getParameters(await SharedPropsService.getUrlParams()) : {};
        console.warn("$$$$$$$$$$ PARMAS $$$$$$$$$$", await SharedPropsService.getUrlParams());
        let createUtmObject = {};
        Object.keys(params).forEach((key) => {
            switch (key) {
                case GoogleUtmParams.UTM_CAMPAIGN:
                    createUtmObject = {
                        utmCampaign: params[key],
                        ...createUtmObject
                    };
                    break;
                case GoogleUtmParams.UTM_CONTENT:
                    createUtmObject = {
                        utmContent: params[key],
                        ...createUtmObject
                    };
                    break;
                case GoogleUtmParams.UTM_MEDIUM:
                    createUtmObject = {
                        utmMedium: params[key],
                        ...createUtmObject
                    };
                    break;
                case GoogleUtmParams.UTM_SOURCE:
                    createUtmObject = {
                        utmSource: params[key],
                        ...createUtmObject
                    };
                    break;
                case GoogleUtmParams.UTM_TERM:
                    createUtmObject = {
                        utmTerm: params[key],
                        ...createUtmObject
                    };
                    break;
            }
        });
        const partnerAccountId = _user?.linkedPartnerAccounts[0]?.accountId;
        // const context = await asyncStorage.get(StoreKey.CONTEXT);
        const context = 'PARTNER';
        // take source from param, with default as MARKETING_MFC,
        const sourceQuery = await sharedPropsService.getSource();
        let registerLeadBody = {
            phoneNumber: phone,
            pan: pan,
            leadTrackingDetails: createUtmObject,
            partnerAccountId: ref,
            source: 'PARTNER_DASHBOARD',
        };
        if (partnerAccountId && partnerAccountId !== '') {
            registerLeadBody = {
                ...registerLeadBody,
                partnerAccountId: partnerAccountId,
            };
        }
        if (!isEmpty(createUtmObject)) {
            registerLeadBody = {
                ...registerLeadBody,
                leadTrackingDetails: createUtmObject
            };
        }
        if (!isResend) {
            const registerLeadResponse = await network.post(`${api.RegisterALead}`, registerLeadBody, {
                headers: await getAuthHeaders()
            }, async () => {
                return;
            }, {
                isPartnerPlatform: true,
            });
            if (registerLeadResponse?.status === 200) {
                leadId = registerLeadResponse?.data?.leadId;
                const mfCentralInitRequestBody = {
                    leadId: leadId
                };
                const mfCentralInitResponse = await network.post(`${api.MFCentralTriggerOtpV2}`, mfCentralInitRequestBody, {
                    headers: await getAuthHeaders()
                }, async () => {
                    return;
                }, {
                    isPartnerPlatform: true
                });
                if (context !== 'PARTNER') {
                    instrumentTrack('MFC_CHECK_LIMIT_BUTTON_CLICKED', { pan: pan, phone: phone });
                    addUseProperty('lead_id', leadId);
                }
                console.log("mfCentralInitResponse 123: ", mfCentralInitResponse);
                if (mfCentralInitResponse?.status === 200) {
                    const data = mfCentralInitResponse?.data;
                    clientRefNo = data?.clientRefNo;
                    otpRef = data?.otpRef;
                    reqId = data?.reqId;
                    await sharedPropsService.setMfCentralInitResponse({
                        clientRefNo: data?.clientRefNo,
                        otpRef: data?.otpRef,
                        reqId: data?.reqId,
                        leadId: registerLeadResponse?.data?.leadId
                    });
                    // await navigateWithClear(
                    //     ROUTE.CHECK_LIMIT_MFC_OTP,
                    //     {
                    //         phoneNumber: phone,
                    //         clientRefNo: clientRefNo,
                    //         otpRef: otpRef,
                    //         reqId: reqId,
                    //         leadId: leadId
                    //     });
                    await setDatastore(action.routeId, 'customerPortfolioPage', {
                        activeScreen: "OTP_SCREEN" /* CHECK_CUSTOMER_PORTFOLIO_SCREEN_TYPE.OTP_SCREEN */,
                        clientRefNo: data?.clientRefNo,
                        otpRef: data?.otpRef,
                        reqId: data?.reqId,
                        leadId: registerLeadResponse?.data?.leadId
                    });
                    await setDatastore(action.routeId, 'continue', {
                        loading: false
                    });
                }
                else if (mfCentralInitResponse?.response?.status === 400) {
                    await setDatastore(action.routeId, 'customerPortfolioPage', {
                        activeScreen: "NO_PORTFOLIO_SCREEN" /* CHECK_CUSTOMER_PORTFOLIO_SCREEN_TYPE.NO_PORTFOLIO_SCREEN */
                    });
                }
            }
            if (registerLeadResponse?.status === 500) {
                await navigate(ROUTE.CHECK_LIMIT_ALERT_MODAL);
            }
        }
        //this is only for resend scenario
        if (isResend) {
            await setDatastore(ROUTE.CHECK_LIMIT_MFC_OTP, 'OtpInput', {
                state: InputStateToken.DEFAULT,
            });
            const mfCentralInitData = await sharedPropsService.getMfCentralInitResponse();
            const leadId = mfCentralInitData?.leadId;
            const mfCentralInitRequestBody = {
                leadId: leadId
            };
            const mfCentralInitResponse = await network.post(`${api.MFCentralTriggerOtpV2}`, mfCentralInitRequestBody, {
                headers: await getAuthHeaders()
            }, async () => {
                return;
            }, {
                isPartnerPlatform: true
            });
            if (mfCentralInitResponse?.status === 200) {
                const data = mfCentralInitResponse?.data;
                clientRefNo = data?.clientRefNo;
                otpRef = data?.otpRef;
                reqId = data?.reqId;
                await sharedPropsService.setMfCentralInitResponse({
                    clientRefNo: data?.clientRefNo,
                    otpRef: data?.otpRef,
                    reqId: data?.reqId
                });
            }
            if (mfCentralInitResponse?.status === 500) {
                await navigate(ROUTE.CHECK_LIMIT_ALERT_MODAL);
            }
        }
        await setDatastore(action.routeId, 'continue', {
            loading: false
        });
    }
};
